import React from 'react';

export function makeStyles(Component) {
  function ComponentWithStylesProp(props) {
//    console.log("POPS", props)
//
//    if(props.styleSheet){
//        debugger;
//    }
    return (
      <Component
        {...props}
      />
    )
  }
  return ComponentWithStylesProp;
}